import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

/**
 * Shell for the policy pages.
 *
 * These exist for two reasons beyond good manners:
 *   1. Razorpay will not activate a merchant account without Terms, Privacy,
 *      Cancellation & Refunds, Contact and Pricing pages live on the domain.
 *   2. IT Rules 2021 require published grievance-redressal details.
 *
 * The content below is a DRAFT written from how the product actually behaves.
 * It is not legal advice and has not been reviewed by a lawyer.
 */
export default function LegalLayout({
  title,
  updated,
  children,
}: {
  title: string;
  updated: string;
  children: ReactNode;
}) {
  return (
    <article className="animate-rise mx-auto max-w-[68ch]">
      <p className="eyebrow">Policy</p>
      <h1 className="mt-2 text-4xl font-semibold">{title}</h1>
      <p className="mt-3 text-sm text-[var(--muted)]">Last updated {updated}</p>

      <div
        className="mt-7 rounded-xl border-l-[3px] px-5 py-4 text-sm"
        style={{ borderColor: 'var(--busy)', background: 'var(--busy-soft)' }}
      >
        <p className="font-semibold" style={{ color: 'var(--busy)' }}>
          Draft — not yet reviewed by a lawyer
        </p>
        <p className="mt-1.5 text-[var(--ink-2)]">
          Written from how the product actually works, so counsel has something concrete to edit
          rather than a blank page. Must be reviewed and signed off before launch, and before
          applying for payment-gateway activation.
        </p>
      </div>

      <div className="legal-prose mt-10">{children}</div>

      <nav className="mt-14 flex flex-wrap gap-x-6 gap-y-2 border-t border-[var(--line)] pt-6 text-sm">
        <Link to="/terms" className="text-[var(--ink-2)] hover:text-[var(--ink)]">
          Terms
        </Link>
        <Link to="/privacy" className="text-[var(--ink-2)] hover:text-[var(--ink)]">
          Privacy
        </Link>
        <Link to="/refunds" className="text-[var(--ink-2)] hover:text-[var(--ink)]">
          Refunds
        </Link>
        <Link to="/pricing" className="text-[var(--ink-2)] hover:text-[var(--ink)]">
          Pricing
        </Link>
        <Link to="/contact" className="text-[var(--ink-2)] hover:text-[var(--ink)]">
          Contact
        </Link>
      </nav>
    </article>
  );
}
